import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { showToast } from "./toastSlice";
import { toast } from "./toastTypes";

export const STRIPE_SUCCESS_TIER_KEY = "stripeSuccessTier";

export function StripeSuccessToaster() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    let tier: string | null = null;
    try {
      tier = sessionStorage.getItem(STRIPE_SUCCESS_TIER_KEY);
      if (tier) sessionStorage.removeItem(STRIPE_SUCCESS_TIER_KEY);
    } catch {
      return;
    }
    if (tier !== "supporter" && tier !== "pro") return;

    dispatch(showToast(toast(
      "notice",
      {
        i18nKey: tier === "supporter" ? "pricing.success.supporter" : "pricing.success.pro",
        variant: "success",
      },
      `stripe-success-${tier}-${Date.now()}`,
    )));
  }, [dispatch]);

  return null;
}
